export default "__VITE_ASSET__DdtsDUwT__"